export default "__VITE_ASSET__CihUE732__"